import React from "react";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const DeactivationConfirmationModal = ({ title, content, onOk }) => {
  const { confirm } = Modal;
  return confirm({
    title,
    content,
    onOk,
    icon: (
      <ExclamationCircleOutlined style={{ fontSize: "24px", color: "red" }} />
    ),
    okText: "Sim, inativar",
    okType: "danger",
    cancelText: "Cancelar",
  });
};

export default DeactivationConfirmationModal;
